module.exports = __webpack_public_path__ + "static/media/17e-01-HOME_Los-Angeles-Steve-Turner.b0440a43.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/17e/17e-01-HOME_Los-Angeles-Steve-Turner.jpg
// module id = 214
// module chunks = 0